export default (eventName: string, data: any = null) => {
    // @ts-ignore
    if (window.fathom) {
        // @ts-ignore
        window.fathom.trackEvent(eventName, data)
    } else {
        console.log(`Tracking Fathom event ${eventName}`)
    }
}
